import translation from "./translation.json";
import dispatching from "./dispatching.json";
import sorting from "./sorting.json";
import smartMatch from "./smartMatch.json";
import cargo from "./cargo.json";
import auth from "./auth.json";
import fleet from "./fleet.json";
import equipment from "./equipment.json";
import rentals from "./rentals.json";
import upcoming from "./upcoming.json";
import components from "./components.json";
import economic from "./economic.json";
import types from "./types.json";
import notifications from "./notifications.json";
import invoicing from "./invoicing.json";
import settings from "./settings.json";
import navigation from "./navigation.json";
import modals from "./modals.json";
import expenses from "./expenses.json";
import emissions from "./emissions.json";
import businessCentral from "./businessCentral.json";
import shipmentModal from "./shipmentModal.json";
import formBuilder from "./formBuilder.json";
import liveView from "./liveView.json";
import cargosReport from "./cargosReport.json";
import shipmentDriverReport from "./shipmentDriverReport.json";
import gsGroup from "./gsGroup.json";
import schedules from "./schedules.json";
import extraCO2Types from "./extraCo2Types.json";
import calendarView from "./calendarView.json";
import addCsvXlsx from "./addCsvXlsx.json";
import driverSchedule from "./driverSchedule.json";
import folders from "./folders.json";
import driverNotebook from "./driverNotebook.json";
import orderTemplates from "./orderTemplates.json";
import contractorsPage from "./contractorsPage.json";
import tripletex from "./tripletex.json";
import stopUnits from "./stopUnits.json";
import split from "./split.json";
import singleSignOn from "./single-sign-on.json";
import insights from "./insights.json";
import serverErrors from "./serverErrors.json";

// eslint-disable-next-line
export default {
  translation,
  dispatching,
  sorting,
  smartMatch,
  fleet,
  equipment,
  rentals,
  cargo,
  auth,
  upcoming,
  components,
  economic,
  types,
  notifications,
  invoicing,
  settings,
  navigation,
  modals,
  expenses,
  emissions,
  businessCentral,
  shipmentModal,
  formBuilder,
  liveView,
  cargosReport,
  shipmentDriverReport,
  gsGroup,
  schedules,
  extraCO2Types,
  calendarView,
  addCsvXlsx,
  driverSchedule,
  folders,
  driverNotebook,
  orderTemplates,
  contractorsPage,
  tripletex,
  stopUnits,
  split,
  singleSignOn,
  insights,
  serverErrors,
};
